module.exports = __webpack_public_path__ + "static/img/High_Card.053ef8f.svg";